import {SubjectAreaBO} from "./SubjectAreaBO";
import _ = require("lodash")
import { MessageType } from "../PA.Core/PA.Core.IF.Basic";

export class SubjectAreaBOValidation {

    static ValidateFields(aBO: SubjectAreaBO): Promise<void> {
        const self = this;

        return new Promise((resolve, reject)=>{
            let prefix = "/AZR/SA_"

            //Validate Technical Name
            if(_.isEmpty(aBO.WB_SubjectArea.cif.SOURCE_NAME)) {
                self.addMessage(aBO, "EmptyTchName", "Technical Name cannot be empty");
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyTchName')
            }

            //Validate technical Name prefix
            if(!_.startsWith(aBO.WB_SubjectArea.cif.SOURCE_NAME, prefix)){
                self.addMessage(aBO, "TchNamePrefix", "Technical Name must start with /AZR/SA_");
            } else {
                aBO.ValidateMessageProvider.removeMessage('TchNamePrefix')
            }

            resolve();
        })
    }

    private static addMessage(aBO: SubjectAreaBO, code: string, message: string): void {
        aBO.ValidateMessageProvider.addMessage(
            {
                code: code,
                type: MessageType.Error,
                title: message,
                description: "",
                subtitle: "",
                count: 0
            });
    }
}